export default __webpack_public_path__ + "static/media/diary-screenshot-06.b42e6ee3.png";